import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExternalService } from './external.service';

export interface UnitDetailsResponse {
  status: boolean;
  message?: string;
  data?: {
    unit_details: {
      property_name: string;
      unit_no: string;
      property_unit_no: string;
      rent: string;
      deposit: string;
      availability_status: string;
      vacant_date: string;
      available_date_for_booking: string | null;
      type: string;
    };
    contracts: {
      active: any[];
      inactive: any[];
      draft: any[];
      hold: any[];
      closed: any[];
      cancelled: any[];
    };
    booking_details: any[];
    total_contracts: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class PropertiesSearchService {

  constructor(private externalService: ExternalService) { }

  searchUnitDetails(propertyUnitNo: string): Observable<UnitDetailsResponse> {
    const requestBody = {
      property_unit_no: propertyUnitNo
    };

    return this.externalService.post('/units/get-details', requestBody);
  }
}
